function vennassaInitSwiper(selector, options) {
  if (typeof Swiper === 'undefined') return null;
  if (!document.querySelector(selector)) return null;
  try {
    return new Swiper(selector, options);
  } catch (e) {
    return null;
  }
}

var swiper1 = vennassaInitSwiper(".page_swiper", {
  slidesPerView: 3,
  spaceBetween: 20,
  // loop: true,
  // freeMode: true,
  navigation: {
    nextEl: '.swiper-button-next-page',
    prevEl: '.swiper-button-prev-page',
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },    
  breakpoints: {
      1440: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 20,
      },      
      1024: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      580: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      414: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      375: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      }
    },
});

var swiper2 = vennassaInitSwiper(".custom_swiper", {
  slidesPerView: 3,
  spaceBetween: 20,
	observer:true,//修改swiper自己或子元素时，自动初始化swiper
  observeParents:true,//修改swiper的父元素时，自动初始化swiper
  navigation: {
    nextEl: '.swiper-button-next-custom',
    prevEl: '.swiper-button-prev-custom',
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },    
  breakpoints: {
      1440: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      580: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      414: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      375: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      }
    },
});

var swiper3 = vennassaInitSwiper(".icon_swiper", {
  autoplay: true,
  slidesPerView: 4,
  spaceBetween: 0,
  breakpoints: {
      1440: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      580: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      414: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      375: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
      }
    },
});

class AnimatedCounter {
  constructor(element) {
    this.element = element;
    this.valueElement = element.querySelector('.counter-value');
    this.from = parseInt(element.dataset.from);
    this.to = parseInt(element.dataset.to);
    this.duration = parseInt(element.dataset.duration);
    this.startTime = null;
    this.currentValue = this.from;
  }

  start() {
    this.startTime = performance.now();
    this.animate();
  }

  animate() {
    const currentTime = performance.now();
    const elapsed = currentTime - this.startTime;
    const progress = Math.min(elapsed / this.duration, 1);
    
    this.currentValue = Math.floor(this.from + (this.to - this.from) * progress);
    this.valueElement.textContent = this.formatNumber(this.currentValue);
    
    if (progress < 1) {
      requestAnimationFrame(() => this.animate());
    } else {
      this.currentValue = this.to;
      this.valueElement.textContent = this.formatNumber(this.to);
    }
  }

  formatNumber(num) {
    return num.toLocaleString();
  }
}

// 初始化所有计数器
document.addEventListener('DOMContentLoaded', function() {
  const counters = document.querySelectorAll('.animated-counter');
  counters.forEach(counter => {
    const animatedCounter = new AnimatedCounter(counter);
    animatedCounter.start();
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const mobileMedia = window.matchMedia('(max-width: 749px)');
  const menuBlocks = document.querySelectorAll('.footer .footer-block--menu');

  if (!menuBlocks.length) return;

  function setPanelHeight(block, isOpen) {
    const panel = block.querySelector('.footer-block__details-content');
    if (!panel) return;

    if (isOpen) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    } else {
      panel.style.maxHeight = '0px';
    }
  }

  function openBlock(block) {
    block.classList.add('is-open');
    const heading = block.querySelector('.footer-block__heading');
    if (heading) heading.setAttribute('aria-expanded', 'true');
    setPanelHeight(block, true);
  }

  function closeBlock(block) {
    block.classList.remove('is-open');
    const heading = block.querySelector('.footer-block__heading');
    if (heading) heading.setAttribute('aria-expanded', 'false');
    setPanelHeight(block, false);
  }

  function bindAccordion() {
    menuBlocks.forEach(function (block, index) {
      const heading = block.querySelector('.footer-block__heading');
      const panel = block.querySelector('.footer-block__details-content');

      if (!heading || !panel) return;

      if (mobileMedia.matches) {
        if (!heading.dataset.accordionBound) {
          heading.dataset.accordionBound = 'true';
          heading.setAttribute('role', 'button');
          heading.setAttribute('tabindex', '0');
          heading.setAttribute('aria-expanded', 'false');

          heading.addEventListener('click', function () {
            const isOpen = block.classList.contains('is-open');

            // 只能展开一个
            menuBlocks.forEach(function (item) {
              if (item !== block) closeBlock(item);
            });

            if (isOpen) {
              closeBlock(block);
            } else {
              openBlock(block);
            }
          });

          heading.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              heading.click();
            }
          });
        }

        // 默认全部收起
        closeBlock(block);

        // 如果你想第一个默认展开，用下面两行替换上面的 closeBlock(block)
        // if (index === 0) openBlock(block);
        // else closeBlock(block);
      } else {
        block.classList.remove('is-open');
        heading.removeAttribute('role');
        heading.removeAttribute('tabindex');
        heading.removeAttribute('aria-expanded');
        panel.style.maxHeight = '';
      }
    });
  }

  bindAccordion();

  mobileMedia.addEventListener('change', function () {
    bindAccordion();
  });

  window.addEventListener('resize', function () {
    if (!mobileMedia.matches) return;

    document.querySelectorAll('.footer .footer-block--menu.is-open').forEach(function (block) {
      setPanelHeight(block, true);
    });
  });
});

/* Smile.io Rewards launcher: position + mobile open-panel fallback */
(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let clickFallbackBound = false;
  let lastSmileOpenAt = 0;

  function getSmilePositionTargets() {
    return [
      document.getElementById('smile-ui-lite-container'),
      document.getElementById('smile-ui-container'),
      document.getElementById('smile-ui-lite-launcher-frame-container'),
    ].filter(Boolean);
  }

  function openSmilePanel() {
    if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
      window.SmileUI.openPanel({ deep_link: 'home' });
      return true;
    }
    /* Fallback when Smile JavaScript SDK is off: URL hash deep link */
    if (window.location.hash !== '#smile-home') {
      window.location.hash = 'smile-home';
    } else {
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    }
    return true;
  }

  function getSmileBottomOffset() {
    var cartDrawer = document.querySelector('cart-drawer.active');
    if (!cartDrawer) return '2rem';

    var footer = cartDrawer.querySelector('.drawer__footer');
    if (!footer) return '15rem';

    var footerTop = footer.getBoundingClientRect().top;
    var gapPx = 12;
    var bottomPx = window.innerHeight - footerTop + gapPx;
    return Math.max(bottomPx, 72) + 'px';
  }

  function applySmileLauncherLayout() {
    if (!mobileQuery.matches) return;

    const bottom = getSmileBottomOffset();

    getSmilePositionTargets().forEach(function (node) {
      node.style.setProperty('right', '1.5rem', 'important');
      node.style.setProperty('bottom', bottom, 'important');
      node.style.removeProperty('transform');
      node.style.removeProperty('transform-origin');
      node.style.setProperty('z-index', '10050', 'important');
      node.style.setProperty('pointer-events', 'auto', 'important');
    });

    var frame = document.getElementById('smile-ui-lite-launcher-frame');
    if (frame) {
      frame.style.removeProperty('width');
      frame.style.removeProperty('height');
      frame.style.removeProperty('max-width');
      frame.style.removeProperty('max-height');
      frame.style.setProperty('pointer-events', 'auto', 'important');
    }

    var panel = document.getElementById('smile-ui-lite-panel-container');
    if (panel) {
      panel.style.setProperty('z-index', '10051', 'important');
      panel.style.setProperty('pointer-events', 'auto', 'important');
    }
  }

  function bindSmileClickFallback() {
    if (clickFallbackBound) return;
    clickFallbackBound = true;

    function handleSmileTap(event) {
      if (!mobileQuery.matches) return;
      var now = Date.now();
      if (now - lastSmileOpenAt < 500) return;

      var launcher =
        document.getElementById('smile-ui-lite-launcher-frame-container') ||
        document.getElementById('smile-ui-lite-container') ||
        document.getElementById('smile-ui-container');

      if (!launcher) return;
      if (!launcher.contains(event.target) && event.target !== launcher) return;

      lastSmileOpenAt = now;
      window.setTimeout(function () {
        openSmilePanel();
        var panel = document.getElementById('smile-ui-lite-panel-container');
        if (panel) {
          panel.style.setProperty('z-index', '10051', 'important');
          panel.style.setProperty('pointer-events', 'auto', 'important');
        }
      }, 0);
    }

    document.addEventListener('click', handleSmileTap, true);
    document.addEventListener('touchend', handleSmileTap, { capture: true, passive: true });
  }

  function initSmileLauncherFix() {
    applySmileLauncherLayout();
    bindSmileClickFallback();

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      new MutationObserver(function () {
        applySmileLauncherLayout();
        window.setTimeout(applySmileLauncherLayout, 80);
        window.setTimeout(applySmileLauncherLayout, 350);
      }).observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    var smileObserver = new MutationObserver(function () {
      if (getSmilePositionTargets().length) {
        applySmileLauncherLayout();
        bindSmileClickFallback();
      }
    });
    smileObserver.observe(document.body, { childList: true, subtree: false });

    mobileQuery.addEventListener('change', applySmileLauncherLayout);
    window.addEventListener('resize', applySmileLauncherLayout);
    window.addEventListener('scroll', applySmileLauncherLayout, true);
    document.addEventListener('smile-ui-loaded', function () {
      applySmileLauncherLayout();
      bindSmileClickFallback();
    });
  }

  function initSmileLauncherFixWithRetry() {
    initSmileLauncherFix();
    window.setTimeout(applySmileLauncherLayout, 800);
    window.setTimeout(applySmileLauncherLayout, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmileLauncherFixWithRetry);
  } else {
    initSmileLauncherFixWithRetry();
  }
})();

/* Replace heading tags in Shopify-injected UI (cookie banner) for SEO */
(function () {
  var UI_ROOT_SELECTORS = [
    '#shopify-pc__banner',
    '.shopify-pc__banner__dialog',
    '[class*="shopify-pc"]',
  ];

  function replaceHeadingWithParagraph(heading) {
    if (!heading || heading.dataset.seoHeadingFixed === 'true') return;

    var paragraph = document.createElement('p');
    paragraph.className = heading.className;
    paragraph.id = heading.id;
    paragraph.innerHTML = heading.innerHTML;
    paragraph.dataset.seoHeadingFixed = 'true';

    Array.prototype.forEach.call(heading.attributes, function (attr) {
      if (attr.name === 'class' || attr.name === 'id') return;
      paragraph.setAttribute(attr.name, attr.value);
    });

    heading.replaceWith(paragraph);
  }

  function fixInjectedUiHeadings(root) {
    var scope = root || document;
    UI_ROOT_SELECTORS.forEach(function (selector) {
      scope.querySelectorAll(selector).forEach(function (container) {
        container.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(replaceHeadingWithParagraph);
      });
    });
  }

  function initInjectedUiHeadingFix() {
    fixInjectedUiHeadings();

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (
            node.matches &&
            (node.matches('#shopify-pc__banner') ||
              node.matches('.shopify-pc__banner__dialog') ||
              (node.className && String(node.className).indexOf('shopify-pc') !== -1))
          ) {
            fixInjectedUiHeadings(node);
            return;
          }
          fixInjectedUiHeadings(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInjectedUiHeadingFix);
  } else {
    initInjectedUiHeadingFix();
  }
})();

/* Merge empty Destination cells on Shipping Policy table (rowspan) */
(function () {
  function isShippingPolicyPage() {
    return /\/policies\/shipping-policy\/?$/i.test(window.location.pathname);
  }

  function cellIsEmpty(td) {
    if (!td) return true;
    return (td.textContent || '').replace(/\u00a0/g, ' ').trim() === '';
  }

  function mergePolicyDestinationCells() {
    if (!isShippingPolicyPage()) return;

    var root = document.querySelector('.shopify-policy__body') || document;
    var tables = root.querySelectorAll('table');

    tables.forEach(function (table) {
      if (table.dataset.destinationMerged === 'true') return;

      var rows = table.querySelectorAll('tbody tr');
      var i = 0;
      while (i < rows.length) {
        var row = rows[i];
        var firstCell = row.cells[0];
        if (!firstCell || cellIsEmpty(firstCell)) {
          i += 1;
          continue;
        }

        var span = 1;
        var j = i + 1;
        while (j < rows.length && cellIsEmpty(rows[j].cells[0])) {
          span += 1;
          j += 1;
        }

        if (span > 1) {
          firstCell.setAttribute('rowspan', String(span));
          firstCell.style.verticalAlign = 'middle';
          for (var k = i + 1; k < i + span; k += 1) {
            var emptyCell = rows[k].cells[0];
            if (emptyCell && cellIsEmpty(emptyCell)) {
              emptyCell.parentNode.removeChild(emptyCell);
            }
          }
        }

        i += span;
      }

      table.dataset.destinationMerged = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mergePolicyDestinationCells);
  } else {
    mergePolicyDestinationCells();
  }
})();

/* ==== VENNASSA: fill empty image alt attributes (all languages) ==== */
(function () {
  var SKIP = /^(icon|logo|spacer|placeholder|pixel|divider|bg|arrow|chevron|close|cart|search|menu|star|dot)/i;
  function buildAlt(img) {
    var src = img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('data-srcset') || '';
    var fn = (src.split('?')[0].split('/').pop() || '').replace(/\.[a-z0-9]+$/i, '');
    var name = fn.replace(/[_\-]+/g, ' ')
                 .replace(/\b[0-9a-f]{8,}\b/gi, ' ')
                 .replace(/\b\d{3,}\b/g, ' ')
                 .replace(/\s+/g, ' ')
                 .trim();
    if (!name || name.length < 3 || SKIP.test(name)) return null;
    name = name.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    return (name + ' | VENNASSA').slice(0, 120);
  }
  function fix(root) {
    var scope = root || document;
    var imgs = scope.querySelectorAll('main img, .article img, .rte img, .shopify-policy__body img, .blog img, article img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var cur = img.getAttribute('alt');
      if (cur && cur.trim().length) continue;
      var alt = buildAlt(img);
      if (alt) img.setAttribute('alt', alt);
    }
  }
  if (document.readyState !== 'loading') { fix(); } else { document.addEventListener('DOMContentLoaded', function () { fix(); }); }
  window.addEventListener('load', function () { fix(); });
  setTimeout(function () { fix(); }, 1500);
})();
